import { render, staticRenderFns } from "./StatusCard.vue?vue&type=template&id=148594fb&scoped=true"
import script from "./StatusCard.vue?vue&type=script&lang=js"
export * from "./StatusCard.vue?vue&type=script&lang=js"
import style0 from "./StatusCard.vue?vue&type=style&index=0&id=148594fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148594fb",
  null
  
)

export default component.exports